import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { GRU_SAVING_INFO_LIST_QUERY } from "../Queries";
import useInput from "../../../../Hooks/useInput";
import ListPresenter from "./Presenter/List";
import qs from "qs";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));
  const page = queryString.page ? queryString.page : 1;
  const commonStatus = queryString.commonStatus ? queryString.commonStatus : "";
  const keyword = queryString.keyword ? queryString.keyword : "";
  const keywordInput = useInput(keyword);

  const blockSize = 5;
  const first = 15;
  const skip = first * (page - 1);
  const baseUrl =
    "?" +
    (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
    (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "");

  const { data, loading, error, refetch } = useQuery(
    GRU_SAVING_INFO_LIST_QUERY,
    {
      fetchPolicy: "network-only",
      variables: {
        commonStatus,
        keyword,
        skip,
        first,
      },
    }
  );

  const handleSearch = (e) => {
    e.preventDefault();
    history.push(`/gruSavings${baseUrl}page=1`);
  };

  if (!loading && (error || !data || !data.AdminGruSavingInfoList)) {
    return (
      <div className="alert alert-danger m-t-20">
        목록을 불러오지 못했습니다.
        {error && <div className="f-s-12 m-t-5">{error.message}</div>}
      </div>
    );
  }

  return (
    <ListPresenter
      history={history}
      match={match}
      location={location}
      page={page}
      commonStatus={commonStatus}
      keyword={keyword}
      keywordInput={keywordInput}
      blockSize={blockSize}
      first={first}
      data={data}
      loading={loading}
      refetch={refetch}
      baseUrl={baseUrl}
      handleSearch={handleSearch}
    />
  );
});
